import { createQuery } from '../api/query'
import { MediaAsset } from './types'

export const keyMediaAssets = (arg: string) => [`/media-assets`, arg]
export const useQueryMediaAssets = createQuery<MediaAsset[]>({
    key: keyMediaAssets,
    url: '/media-assets',
})

const keyMediaAsset = (arg: string) => [`/media-asset`, arg]
export const useQueryMediaAsset = createQuery<MediaAsset>({
    key: keyMediaAsset,
    url: '/media-asset',
})

const keyQueryMediaAssets = (arg: string) => [`/upload-media`, arg]
export const useQueryMedia = createQuery<MediaAsset>({
    key: keyQueryMediaAssets,
    url: '/upload-media',
})
